<template>
  <Drawer
    width="1000"
    :title="openedMaterial ? openedMaterial.name : '-'"
    v-model="drawerOpened"
  >
    <Modal
      v-model="removePurchaseModal"
      title="删除采购价"
      @on-ok="removePurchase"
    >
      <p>你确定要删除该采购价吗？</p>
    </Modal>
    <div class="drawer-content">
      <Form
        @submit.native.prevent
        ref="formItem"
        :model="formItem"
        :rules="ruleValidate"
        label-position="top"
      >
        <Row :gutter="16" style="width: 50%">
          <Col span="12">
            <FormItem label="价格" prop="price" required>
              <InputNumber
                :min="0"
                :step="1"
                v-model="formItem.price"
                placeholder="输入价格..."
                style="width: 100%"
              ></InputNumber>
            </FormItem>
          </Col>
          <Col span="12">
            <FormItem label="采购日期" prop="priceDate">
              <DatePicker
                v-model="formItem.priceDate"
                type="date"
                placeholder="不填则默认为今天..."
                style="width: 100%"
              ></DatePicker>
            </FormItem>
          </Col>
        </Row>

        <FormItem label="工厂">
          <CheckboxGroup v-model="formItem.factory">
            <Checkbox
              :label="n.name"
              v-for="n in factoryList"
              :key="n._id"
            ></Checkbox>
          </CheckboxGroup>
        </FormItem>

        <FormItem>
          <Button type="primary" @click="handleSubmit('formItem')">保存</Button>
        </FormItem>
      </Form>

      <Row :gutter="16">
        <Col span="8" v-for="n in factoryList" :key="n._id" class="table-sec">
          <h3>{{ n.name }}</h3>
          <Table
            :columns="columns"
            border
            :data="purchaseByFactory(n._id)"
            height="250"
            size="small"
          >
            <template slot-scope="{ row }" slot="priceDate">
              <Time :time="row.priceDate" type="date" />
            </template>
            <template slot-scope="{ row }" slot="delete">
              <Icon
                type="ios-remove-circle-outline"
                style="cursor: pointer"
                @click="showRemovePurchaseModal(row._id)"
              />
            </template>
          </Table>
        </Col>
      </Row>
    </div>
  </Drawer>
</template>

<script>
import { mapActions, mapState } from "vuex";
import dayjs from "dayjs";

export default {
  name: "MaterialPurchaseDrawer",
  components: {},
  props: {},
  data() {
    return {
      drawerOpened: false,
      openedMaterial: {},
      removePurchaseModal: false,
      currentPriceId: null,
      formItem: {
        price: null,
        priceDate: null,
        factory: [],
      },
      ruleValidate: {
        price: [
          {
            required: true,
            message: "价格为必填项",
            type: "number",
            trigger: "blur",
          },
        ],
        priceDate: [{ required: false }],
      },
      columns: [
        {
          title: "采购日期",
          key: "priceDate",
          slot: "priceDate",
          width: 100,
        },
        {
          title: "价格",
          key: "price",
          align: "right",
        },
        {
          title: "删除",
          key: "delete",
          slot: "delete",
          width: 70,
          align: "center",
        },
      ],
      purchaseData: [],
    };
  },
  computed: {
    ...mapState({
      factoryList: (state) => state.factory.factoryList,
    }),
    purchaseByFactory: function () {
      return (facId) =>
        this.purchaseData
          .filter((e) => e.factory._id === facId)
          .sort((a, b) => new Date(b.priceDate) - new Date(a.priceDate));
    },
  },
  methods: {
    ...mapActions({
      createPurchase: "purchase/createPurchaseAction",
      updatePurchase: "purchase/updatePurchaseAction",
      getPurchases: "purchase/getPurchasesAction",
      deletePurchase: "purchase/deletePurchaseAction",
    }),
    async loadPurchases(material) {
      try {
        const data = await this.getPurchases({
          api: { material: material._id, limit: 99, skip: 0 },
        });
        this.purchaseData = data;
      } catch (error) {
        this.$Message.error(`失败: ${error}`);
      }
    },
    async openDrawer(material) {
      this.$refs["formItem"].resetFields();

      this.openedMaterial = material;
      this.drawerOpened = true;
      this.loadPurchases(material);
    },
    handleSubmit(name) {
      this.$refs[name].validate(async (valid) => {
        if (valid) {
          const factoryIdList = [];
          if (!this.formItem.priceDate || this.formItem.priceDate === "") {
            this.formItem.priceDate = dayjs(new Date()).format(
              "YYYY-MM-DD HH:mm"
            );
          } else {
            this.formItem.priceDate = dayjs(this.formItem.priceDate).format(
              "YYYY-MM-DD HH:mm"
            );
          }
          this.formItem.factory.forEach((e) => {
            const f = this.factoryList.find((x) => x.name === e);
            factoryIdList.push(f._id);
          });
          try {
            const purchase = await this.createPurchase({
              ...this.formItem,
              material: this.openedMaterial._id,
              factory: factoryIdList,
            });
            this.loadPurchases(this.openedMaterial);
            this.purchaseData.concat(purchase);
            this.$refs["formItem"].resetFields();
            this.$Message.success("保存成功!");
          } catch (error) {
            this.$Message.error(`失败: ${error}`);
          }
        } else {
          this.$Message.error("保存失败!");
        }
      });
    },
    showRemovePurchaseModal(id) {
      this.currentPriceId = id;
      this.removePurchaseModal = true;
    },
    async removePurchase() {
      const id = this.currentPriceId;
      try {
        await this.deletePurchase({ id });
        const i = this.purchaseData.findIndex((e) => e._id === id);
        if (i > -1) this.purchaseData.splice(i, 1);
      } catch (error) {
        this.$Message.error(`失败: ${error}`);
      }
    },
  },
};
</script>

<style scoped lang="stylus">
.table-sec
  height 290px
  margin-bottom 8px
</style>
